<template>
  <div class="pi_container">
    <div class="el-icon-circle-close pi_close_btn" @click="closePI" />
    <el-row class="pi_box">
      <el-col :span="5" class="pi_btn_type">
        <div
          :class="clickType === 1 ? 'clickBtn' : 'noClickBtn'"
          @click="clickTypeChange(1)"
        >
          <svg-icon icon-class="orderPackage" />
          {{ $t('collectionCenter.smallParcelPriceInquiry') }}
        </div>
        <br>
        <div
          :class="clickType === 2 ? 'clickBtn' : 'noClickBtn'"
          @click="clickTypeChange(2)"
        >
          <svg-icon icon-class="truck" />
          {{ $t('collectionCenter.largeParcelPriceInquiry') }}
        </div>
      </el-col>
      <el-col :span="19" style="padding: 10px 100px; box-sizing: border-box">
        <el-form
          ref="ruleRef"
          :model="ruleForm"
          :rules="rules"
          class="pi_form"
        >
          <el-row type="flex" style="justify-content: space-between;align-items: center;flex-wrap: wrap">
            <el-col :span="24">
              <!-- 客户 -->
              <el-form-item
                :label="$t('placeOrder.client')" prop="customerId"
                style="width: 100%"
              >
                <el-select
                  v-model="ruleForm.customerId"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable filterable
                  style="width: 100%"
                  remote reserve-keyword
                  :remote-method="getCustomerPage"
                  @clear="getCustomerPage"
                >
                  <el-option
                    v-for="item in customerList"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <!-- 发件邮编 -->
              <el-form-item
                :label="$t('uploadFile.senderPostalCode')"
                prop="senderZipcode"
              >
                <el-input
                  v-model.trim="ruleForm.senderZipcode"
                  :placeholder="$t('placeOrder.input8ZipCode')"
                  :maxlength="9"
                  clearable style="width: 100%"
                  @input="filterNumber('senderZipcode')"
                  @blur="zipCodeVal('senderZipcode')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <!-- 收件邮编 -->
              <el-form-item
                :label="$t('uploadFile.recipientPostalCode')"
                prop="receiveZipcode"
              >
                <el-input
                  v-model.trim="ruleForm.receiveZipcode"
                  :placeholder="$t('placeOrder.input8ZipCode')"
                  :maxlength="9"
                  clearable style="width: 100%"
                  @input="filterNumber('receiveZipcode')"
                  @blur="zipCodeVal('receiveZipcode')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!-- 包裹重量(KG) -->
              <el-form-item
                :label="$t('placeOrder.parcelWeight')"
                prop="weight"
              >
                <el-input
                  v-model="ruleForm.weight"
                  placeholder="0.00"
                  clearable style="width: 100%"
                  @input="(val) => filterInput('weight', val)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!-- 包裹总体积 -->
              <el-form-item
                :label="$t('GlobalSetObj.PackageTotalWeight') + (clickType === 1 ? '(cm³)' : '(m³)')"
                prop="totalParcelDeclaredVolume"
              >
                <el-input
                  v-model="ruleForm.totalParcelDeclaredVolume"
                  placeholder="0.00"
                  :max="999"
                  clearable style="width: 100%;margin-bottom: 5px"
                  @input="filterInputVolume"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!-- 长宽高（选填） -->
              <div class="pi_ckg_box">
                <span class="pi_ckg_title">{{ $t('collectionCenter.lengthWidthHeightOptional') }}</span>
                <span class="pi_ckg_input">
                  <el-input
                    v-model="ruleForm.length" clearable style="width: 30%"
                    @input="(val) => filterInputCKG('length', val)"
                  >
                    <span slot="prefix">{{ $t('collectionCenter.long') }}</span>
                    <span slot="suffix">{{ clickType === 1 ? 'cm' : 'm' }}</span>
                  </el-input>
                  <el-input
                    v-model="ruleForm.width" clearable style="width: 30%"
                    @input="(val) => filterInputCKG('width', val)"
                  >
                    <span slot="prefix">{{ $t('collectionCenter.width') }}</span>
                    <span slot="suffix">{{ clickType === 1 ? 'cm' : 'm' }}</span>
                  </el-input>
                  <el-input
                    v-model="ruleForm.height" clearable style="width: 30%"
                    @input="(val) => filterInputCKG('height', val)"
                  >
                    <span slot="prefix">{{ $t('collectionCenter.height') }}</span>
                    <span slot="suffix">{{ clickType === 1 ? 'cm' : 'm' }}</span>
                  </el-input>
                </span>
              </div>
              <span class="pi_ckg_title" style="color: #878787 !important">
                {{ clickType === 1 ? $t('collectionCenter.volumeUnitNote') : $t('collectionCenter.volumeUnitNoteM3') }}
              </span>
            </el-col>
            <el-col :span="24" style="margin-top: 15px">
              <!-- 开票金额 -->
              <el-form-item
                :label="$t('placeOrder.InvoiceAmount') + '(R$)'"
                prop="invoiceMoney"
              >
                <el-input
                  v-model="ruleForm.invoiceMoney"
                  placeholder="0.00"
                  clearable style="width: 100%"
                  @input="(val) => filterInput('invoiceMoney', val)"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div
          class="el-icon-search pi_search_btn"
          @click="queryQuote"
        >
          <!-- 查询报价 -->
          {{ $t('collectionCenter.queryQuote') }}
        </div>
        <div v-if="isloadingBtn" class="pi_loading_btn">
          <!-- 等待查询报价... -->
          {{ $t('collectionCenter.waitingForQuote') }}
        </div>
        <div v-else class="pi_sum_box">
          <svg-icon icon-class="coins" />{{ $t('collectionCenter.estimatedShippingCost') }}
          <br>
          <span class="pi_sum">R$ {{ sumPrice }}</span>
        </div>
        <div v-if="!isloadingBtn" class="pi_sum_tips">
          <!-- 预估运费，仅供参考，请以实际应付金额为准 -->
          {{ $t('collectionCenter.estimatedShippingDisclaimer') }}
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { CustomerPage } from '@/api/customer';
import { checkFloatNumber } from '@/utils/validate';
import { checkedzipcode, queryCalculateFee, getBillableWeight } from '@/api/orderApi';
import { Loading } from 'element-ui';
const PARAMS = {
  cargoType: 0,
  orderPackageType: 1,
  expressType: 2,
  customerId: '',
  senderZipcode: '',
  receiveZipcode: '',
  weight: '',
  totalParcelDeclaredVolume: '',
  length: '',
  width: '',
  height: '',
  invoiceMoney: ''
};
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const reqZipcode = field => {
      return (rule, value, callback) => {
        const reg = /^\d{8}$/;
        if (!reg.test(value) || value.length < 8) {
          const errorKey = field === 'senderZipcode'
            ? 'collectionCenter.invalidSenderPostcode'
            : 'collectionCenter.invalidRecipientPostcode';
          return callback(new Error(this.$t(errorKey)));
          // return callback(new Error(this.$t('collectionCenter.invalidSenderPostcode')));
          // return callback(new Error(this.$t('collectionCenter.invalidRecipientPostcode')));
        } else {
          const data = {
            zipcode: value
          };
          const loading = Loading.service({
            fullscreen: true,
            lock: true,
            spinner: 'el-icon-loading',
            text: 'loading...',
            background: 'rgba(250, 250, 250, 0.6)'
          });
          checkedzipcode(data).then(res => {
            loading.close();
            if (res.code === 200) {
              return callback();
            }
          }).catch((err) => {
            loading.close();
            return callback(new Error(err.msg));
          });
        }
      };
    };
    return {
      billableWeight: 0,
      clickType: 1,
      customerList: [], // 客户列表
      ruleForm: {
        ...PARAMS
      },
      rules: {
        customerId: [{ required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: ['blur', 'change'] }],
        senderZipcode: [
          { required: true, message: this.$t('placeOrder.pleaseInput') },
          {
            validator: reqZipcode('senderZipcode'), trigger: 'blur'
          }
        ],
        receiveZipcode: [
          { required: true, message: this.$t('placeOrder.pleaseInput') },
          {
            validator: reqZipcode('receiveZipcode'), trigger: 'blur'
          }
        ],
        weight: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: ['blur', 'change'] },
          {
            validator: (rule, value, callback) => {
              const weightNum = parseFloat(value);
              if (weightNum <= 0) {
                return callback(new Error(this.$t('collectionCenter.mustBeGreaterThanZero')));
              }
              if (value.includes('.') && value.split('.')[1].length > 3) {
                return callback(new Error(this.$t('placeOrder.最多保留3位小数')));
              }
              if (this.clickType === 1) {
                if (weightNum > 30) {
                  return callback(new Error(this.$t('collectionCenter.maxWeight30KG')));
                }
              } else if (this.clickType === 2) {
                if (weightNum < 10.001) {
                  return callback(new Error(this.$t('collectionCenter.minWeight10kg')));
                }
                // 需要校验最大值：用checkFloatNumber
                if (checkFloatNumber(value) !== true) {
                  if (checkFloatNumber(value) === 1) {
                    return callback(new Error(this.$t('placeOrder.beyondRange')));
                  } else {
                    return callback(new Error(this.$t('placeOrder.float2Number')));
                  }
                }
              }
              callback();
            }
          }
        ],
        totalParcelDeclaredVolume: [
          { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
          {
            validator: (rule, value, callback) => {
              const volumeNum = parseFloat(value);
              if (volumeNum <= 0) {
                return callback(new Error(this.$t('collectionCenter.mustBeGreaterThanZero')));
              }
              if (value.includes('.') && value.split('.')[1].length > 6) {
                return callback(new Error(this.$t('collectionCenter.maxSixDecimals')));
              }
              callback();
            }
          }
        ],
        invoiceMoney: [
          { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
          {
            validator: (rule, value, callback) => {
              const reg = /^(0|[1-9]\d*)(\.\d{1,2})?$/;
              if (!reg.test(value)) {
                return callback(new Error(this.$t('collectionCenter.minZeroMaxTwoDecimals')));
              }
              callback();
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      isloadingBtn: true,
      sumPrice: '--'
    };
  },
  watch: {
    'isShow': {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.ruleForm = { ...PARAMS };
          this.getCustomerPage();
        }
      }
    }
  },
  methods: {
    // 千分位符号处理
    formatThousand(value) {
      if (!value && value !== 0) return value;
      const num = typeof value === 'number' ? value : parseFloat(String(value));
      if (isNaN(num)) return value;

      if (this.$i18n.locale === 'zh') {
        return num.toLocaleString('en-US');
      } else {
        return num.toLocaleString('de-DE');
      }
    },
    closePI() {
      // 提示是否关闭该窗口
      this.$confirm(this.$t('collectionCenter.closeQuoteTips'), this.$t('basicData.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'), // '确定'
        cancelButtonText: this.$t('collectionCenter.cancel') // '取消'
      })
        .then(() => {
          this.$emit('closePI');
        })
        .catch(() => {
          console.log('取消关闭');
        });
    },
    getCustomerPage(name = '') {
      const param = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          quickSearch: name
        }
      };
      CustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    zipCodeVal(type) {
      if (this.ruleForm[type]) {
        this.ruleForm[type] = this.ruleForm[type].slice(0, 8);
      }
      // this.$refs.ruleRef.validateField(type);
    },
    filterNumber(type) {
      this.ruleForm[type] = this.ruleForm[type].replace(/\D/g, '');
    },
    clickTypeChange(type) {
      this.clickType = type;
      this.ruleForm.cargoType = type === 1 ? 0 : type === 2 ? 1 : null;
      this.ruleForm.orderPackageType = type === 1 ? 1 : type === 2 ? 4 : null;
      // 清空所有输入 / 仅清空总体积、长宽高、包裹重量
      this.ruleForm.weight = '';
      this.ruleForm.totalParcelDeclaredVolume = '';
      this.ruleForm.length = '';
      this.ruleForm.width = '';
      this.ruleForm.height = '';
      this.sumPrice = 0;
      this.isloadingBtn = true;
      this.$nextTick(() => {
        this.$refs.ruleRef.clearValidate();
      });
    },
    filterInput(type, val) {
      this.ruleForm[type] = val.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
    },
    filterInputVolume(val) {
      this.ruleForm.totalParcelDeclaredVolume = val.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
      this.ruleForm.length = '';
      this.ruleForm.width = '';
      this.ruleForm.height = '';
    },
    filterInputCKG(type, val) {
      let filteredVal = val.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
      if (['length', 'width', 'height'].includes(type)) {
        const parts = filteredVal.split('.');
        if (parts.length > 1 && parts[1].length > 2) {
          filteredVal = parts[0] + '.' + parts[1].substring(0, 2);
        }
        this.ruleForm[type] = filteredVal;
      }
      this.$nextTick(() => {
        const length = parseFloat(this.ruleForm.length) || 0;
        const width = parseFloat(this.ruleForm.width) || 0;
        const height = parseFloat(this.ruleForm.height) || 0;
        if (length > 0 && width > 0 && height > 0) {
          const volume = length * width * height;
          this.ruleForm.totalParcelDeclaredVolume = volume.toFixed(6).replace(/\.?0+$/, '');
        }
      });
    },
    queryQuote() {
      console.log('this.ruleForm', this.ruleForm);
      this.$refs.ruleRef.validate((valid) => {
        if (valid) {
          // 询价预估金额不需要对小件进行处理
          if (this.clickType === 2) {
            // 提交前调用大件计费重量
            this.getBigFreightWeight();
          }
        }
      });
    },
    enquiryResult() {
      this.sumPrice = 0; // 先置为0
      this.isloadingBtn = true; // 等待查询报价...
      // 需要添加加载动画，避免多次点击
      const loading = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: 'loading...',
        background: 'rgba(250, 250, 250, 0.6)'
      });
      const ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
      ruleForm.weight = this.billableWeight;
      queryCalculateFee(ruleForm).then((res) => {
        if (res.code === 200) {
          this.sumPrice = this.formatThousand(res.data.totalFee);
          this.isloadingBtn = false;
        } else {
          this.sumPrice = 0;
        }
      }).finally(() => {
        loading.close();
      });
    },
    // 大件计费重量
    getBigFreightWeight() {
      const param = {
        cargoType: this.ruleForm.cargoType,
        orderPackageType: this.ruleForm.orderPackageType,
        expressType: this.ruleForm.expressType,
        customerId: this.ruleForm.customerId,
        senderZipcode: this.ruleForm.senderZipcode,
        receiveZipcode: this.ruleForm.receiveZipcode,
        weight: this.ruleForm.weight,
        length: this.ruleForm.length,
        width: this.ruleForm.width,
        height: this.ruleForm.height,
        invoiceMoney: this.ruleForm.invoiceMoney,
        volume: this.ruleForm.totalParcelDeclaredVolume
      };
      getBillableWeight(param).then((res) => {
        if (res.code === 200) {
          this.billableWeight = res.data;
          this.enquiryResult();
        }
      });
    }

  }
};
</script>

<style lang="scss" scoped>
.pi_close_btn {
  position: absolute;right: 15px;top: 15px;
  z-index: 1;
  font-size: 25px; color: #606266;
  transition: color 0.3s ease;
}
.pi_close_btn:hover { color: #49bf5b; }
.pi_close_btn:active { color: #33b44d; }
.pi_container {
  position: absolute;
  top: 0;bottom: 0;left: 0;right: 0;
  background: transparent;
}
.pi_box {
  width: 100%;height: 100%;
  .pi_btn_type {
    background: #f9fafc;
    text-align: center;
    height: 100%;
    padding: 80px 20px;
  }
}
.pi_btn_type .clickBtn, .pi_btn_type .noClickBtn {
  margin-bottom: 00px;
  padding: 12px;border-radius: 10px;
  box-sizing: border-box;
  cursor: default;
  font-size: 15px;font-weight: bold;
}
.clickBtn {
  color: #fff;
  background: #33b44d;
}
.noClickBtn {
  background: #eef2f7;
}
.pi_form ::v-deep .el-input__inner {
  border-radius: 14px !important;
}
.pi_ckg_box { background: #f9fafc;padding: 10px 15px; border-radius: 14px;box-sizing: border-box; }
.pi_ckg_title { color: #7f849f;font-size: 13px;line-height: 13px; }
.pi_ckg_input { display: flex;justify-content: space-between;align-items: center;width: 100%; }
.pi_ckg_input ::v-deep .el-input__inner { text-align: center; }
.pi_ckg_input ::v-deep .el-input__prefix, .pi_ckg_input ::v-deep .el-input__suffix {
  display: flex;justify-content: center;align-items: center;color: #888480;font-size: 13px;
}
.pi_search_btn {
  cursor: default;
  width: 100%;
  background: #33b44d;padding: 13px; border-radius: 20px;box-sizing: border-box;
  text-align: center;font-size: 15px;color: #fff;font-weight: bold;
}
.pi_search_btn:hover { background: #49bf5b; }
.pi_search_btn:active { background: #33b44d; }
.pi_loading_btn {
  background: #f8fafd;padding: 13px; border-radius: 20px;box-sizing: border-box;
  text-align: center;font-size: 14px;color: #878787;margin: 20px 0;
}
.pi_sum_box { font-size: 14px; font-weight: bold;text-align: center; background: #f8fafd;border-radius: 14px;padding: 15px;box-sizing: border-box;margin-top: 20px; margin-bottom: 5px; }
.pi_sum { color: #2c7a4d; font-size: 35px; font-weight: bold;line-height: 35px;display: inline-block; margin-top: 8px }
.pi_sum_tips { text-align: center;color: #e80e0e;font-size: 13px;margin-bottom: 30px; }
</style>
